import { AuthContext } from "@src/auth/use-auth-context";
import store from "@src/reducers/store";

export class AuthenticationRepository {
  private getAuthContext(): AuthContext | null {
    const authContext: AuthContext | null =
      store.getState().yourSlice.authContext;

    if (!authContext) {
      throw new Error(
        "AuthContext is null. That can happen if user is not logged in.",
      );
    }
    return authContext;
  }

  public getAccessToken(): string {
    const authContext = this.getAuthContext();
    return authContext.accessToken;
  }

  public getCustomerNamespace(): string {
    const authContext = this.getAuthContext();
    return authContext.customerNamespace;
  }
}
